module.exports = __webpack_public_path__ + "img/calc.efe1547c.png";